// One delegated document-level listener per behaviour, matching every
// [lt-single-submit]/[lt-single-click] call site across the ~77 views that carry those attributes.
// A plain module rather than a Stimulus controller: there is no per-element state or targets here,
// and this way none of those views need a markup change.
//
// The submit guard matches on `event.target`, not `closest`: a native "submit" event's target is
// always the <form> itself and never bubbles from a descendant button. That leaves the five sites
// where the attribute sits on a submit_tag rather than the form unreachable, as they always were.
document.addEventListener("submit", event => {
  if (!event.target.matches("[lt-single-submit]")) { return; }

  event.target.querySelectorAll("input[type='submit']").forEach(input => { input.disabled = true; });
});

// Old ltSingleClick.js bound `element.on("click", fn)` directly to the element carrying the
// attribute, so a click anywhere inside it (not just exactly on it) added the class. `closest`
// reproduces that; a plain `matches` would miss a click on a child (e.g. an icon inside the link).
document.addEventListener("click", event => {
  const target = event.target.closest("[lt-single-click]");
  if (!target) { return; }

  target.classList.add("btn-disabled");
});
